import { createContext } from 'react';
import { noop } from '../../lib/utils';

const DefaultGlobalContextValue = {
  analytics: {
    tagEvent: noop,
    tagPageView: noop,
    isInitialized: false,
  },
  config: {
    consumerHost: 'www.gasbuddy.com',
    googleAppId: null,
    identityHost: 'iam.gasbuddy.com',
    imagesHost: 'images.gasbuddy.io',
    isMobile: false,
    localyticsKey: null,
    payHost: 'pay.gasbuddy.com',
    payNgHost: 'enroll.gasbuddy.com',
    publicPath: '/',
    recaptchaSiteKey: null,
    sywAppId: null,
    sywHost: 'shopyourway.com',
    trackerHost: 'tracker.gasbuddy.com',
  },
  profile: {
    accountId: null,
    memberName: null,
  },
};

const GlobalContext = createContext();

export {
  GlobalContext as default,
  DefaultGlobalContextValue,
};
